export default function ElectricalServices() {
  const services = [
    {
      icon: 'ri-flashlight-line',
      title: 'Electrical Repairs',
      description: 'Fast and reliable repairs for faulty wiring, circuit breakers, outlets, switches, and lighting fixtures to restore safe electrical function'
    },
    {
      icon: 'ri-home-gear-line',
      title: 'Panel Upgrades',
      description: 'Electrical panel replacement and upgrades to handle modern power demands, improve safety, and support new appliances or additions'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Lighting Installation',
      description: 'Indoor and outdoor lighting design and installation including recessed lights, chandeliers, landscape lighting, and smart lighting systems'
    },
    {
      icon: 'ri-plug-line',
      title: 'Outlet & Switch Installation',
      description: 'Installation of new outlets, GFCI outlets, USB outlets, dimmer switches, and smart switches throughout your home or business'
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'Safety Inspections',
      description: 'Comprehensive electrical safety inspections to identify hazards, code violations, and potential issues before they become problems'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Commercial Electrical',
      description: 'Complete commercial electrical services including tenant improvements, office wiring, emergency lighting, and code compliance'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Complete Electrical Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From routine repairs to complex installations, our network of licensed electricians provides comprehensive electrical solutions for El Paso
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-orange-500 text-white rounded-lg mb-6">
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
